import React, { FC } from 'react';
import { OperatorPanelNoConnectorProps } from './OperatorPanelNoConnector';
import { ContentUnavailableCentralPart } from './ContentUnavailableCentralPart';
import UnavailableContent from './UnavailableContent';
import { subStatuses } from '@helpers';
import { font as initialFont } from '@styles/fonts';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface OperatorPanelMachineOfflineProps extends OperatorPanelNoConnectorProps {
  machineSubStatus: string;
}

const OperatorPanelMachineOffline: FC<OperatorPanelMachineOfflineProps> = ({
  CC,
  machineName,
  isOperator,
  machineStatus,
  time,
  machineSubStatus,
  insetBottom,
  insetTop,
  scale,
  font = initialFont,
}) => {
  const titleConfig: Record<string, { text: string; width?: number }> = {
    [subStatuses.NotPingable]: {
      text: 'Machine Off',
    },
    [subStatuses.ConnectionFailed]: {
      text: 'No Connection Possible',
      width: 608,
    },
    [subStatuses.Offline]: {
      text: 'Machine Offline',
    },
  };

  const title = titleConfig[machineSubStatus];

  if (!title) return null;

  return (
    <UnavailableContent {...{ CC, machineName, machineStatus, isOperator, insetBottom, insetTop, scale, font, testID: TEST_IDS.operatorPanel.unavailable.machineOffline }}>
      <ContentUnavailableCentralPart
        {...{
          CC,
          title: title.text,
          ...(title?.width ? { titleWidth: title.width } : {}),
          titleFont: 'Roboto Extra Large Title',
          titleColor: 'Label/Light/Always Light Tertiary',
          timeMarginTop: 18,
          timeFont: 'Large Title Normal',
          time,
          scale,
          font,
        }}
      />
    </UnavailableContent>
  );
};

export default OperatorPanelMachineOffline;
